import enCommon from './en/common';
import enHome from './en/home';
import enPages from './en/pages';

import jaCommon from './ja/common';
import jaHome from './ja/home';
import jaPages from './ja/pages';

const messages: Record<string, { translation: Record<string, string> }> = {
  en: {
    translation: {
      ...enCommon,
      ...enHome,
      ...enPages,
    },
  },
  ja: {
    translation: {
      ...jaCommon,
      ...jaHome,
      ...jaPages,
    },
  },
};

export default messages;